import { ValueOfIconUIType } from '../icon/icon-ui-type';

export const ButtonType = {
    primary: 'primary',
    secondary: 'secondary',
    plain: 'plain'
};
export const ButtonSize = {
    extraSmall: 'extra-small',
    small: 'small',
    large: 'large'
};

type ValueOf<T> = T[keyof T];

export type ValueOfButtonType = ValueOf<typeof ButtonType>;
export type ValueOfButtonSize = ValueOf<typeof ButtonSize>;

export interface ButtonOptions {
    linkTitle: string;
    buttonText?: string;
    type: ValueOfButtonType;
    size: ValueOfButtonSize;
    fullWidth: boolean;
    disabled: boolean;
    iconStart: ValueOfIconUIType;
    iconEnd: ValueOfIconUIType;
}
